import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

interface PageLayoutProps extends LayoutProps {
    header?: ReactNode
    footer?: ReactNode
    after?: ReactNode
    mainClassName?: string
}

export const Layout: FC<PageLayoutProps> = ({ children, header, footer, after, mainClassName }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            {header}

            <main id='main' className={mainClassName ?? 'flex-1'}>
                {children}
            </main>

            {footer}
            {after}
        </div>
    )
}
